// Plant-limit upsell wiring (§242). The backend returns HTTP 402 with a body
// `{error, resource:"plants", limit, count, upgrade_url}` when a create would
// exceed the plan's plant cap. There is NO global 402 interceptor (api.ts handles
// 401 only), so each create call site detects the plant-limit 402 and fires a
// window event; the app-wide <UpsellGate/> listens and opens the upgrade modal.
import { errStatus } from './errors'

export const PLANT_UPSELL_EVENT = 'grafty:plant-limit-hit'

type Resourced = { response?: { data?: { resource?: string } } }

/** A 402 whose body names the `plants` resource = the tenant hit their plant cap
 *  (distinct from a feature-gate 402, whose body carries `flag`, not `resource`). */
export function isPlantLimit(e: unknown): boolean {
  if (errStatus(e) !== 402) return false
  return (e as Resourced | null | undefined)?.response?.data?.resource === 'plants'
}

/** Fire the app-wide event so <UpsellGate/> opens the upgrade modal immediately —
 *  a hard wall, shown regardless of the sustained-days auto-show threshold. */
export function triggerPlantUpsell(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(PLANT_UPSELL_EVENT))
  }
}

/** If `e` is a plant-limit 402, open the upsell modal and return true (so the
 *  caller can skip its generic error handling). */
export function handlePlantLimit(e: unknown): boolean {
  if (isPlantLimit(e)) {
    triggerPlantUpsell()
    return true
  }
  return false
}
